// // import React, { useEffect, useState } from "react";
// // import { supabase } from "../lib/supabaseClient.ts";

// // const getImageUrl = (path) => {
// //   const { data } = supabase.storage.from("animalia").getPublicUrl(path);
// //   return data?.publicUrl || "";
// // };

// // export default function GestionnaireSliderPrincipal() {
// //   const [mainSlider, setMainSlider] = useState([]);
// //   const [chargement, setChargement] = useState(true);
// //   const [erreur, setErreur] = useState(null);

// //   const [elementModifie, setElementModifie] = useState(null);
// //   const [formulaire, setFormulaire] = useState({
// //     title: "",
// //     image_path: "",
// //   });
// // const [previewUrl, setPreviewUrl] = useState("");

// // useEffect(() => {
// //   if (formulaire.image_path) {
// //     const url = getImageUrl(formulaire.image_path);
// //     setPreviewUrl(url);
// //   }
// // }, [formulaire.image_path]);

// //   const chargerDonnees = async () => {
// //     setChargement(true);
// //     const { data, error } = await supabase.from("main").select("*");
// //     if (error) {
// //       setErreur(error.message);
// //     } else {
// //       setMainSlider(data);
// //       setErreur(null);
// //     }
// //     setChargement(false);
// //   };

// //   useEffect(() => {
// //     chargerDonnees();
// //   }, []);

// //   const gererChangement = (e) => {
// //     setFormulaire((prev) => ({
// //       ...prev,
// //       [e.target.name]: e.target.value,
// //     }));
// //   };

// //   const gererSoumission = async (e) => {
// //     e.preventDefault();

// //     if (elementModifie) {
// //       const { error } = await supabase
// //         .from("main")
// //         .update(formulaire)
// //         .eq("id", elementModifie.id);

// //       if (error) {
// //         alert("Échec de la mise à jour : " + error.message);
// //       } else {
// //         alert("Mis à jour avec succès");
// //         setElementModifie(null);
// //         setFormulaire({ title: "", image_path: "" });
// //         chargerDonnees();
// //       }
// //     } else {
// //       const { error } = await supabase.from("main").insert([formulaire]);

// //       if (error) {
// //         alert("Échec de l'ajout : " + error.message);
// //       } else {
// //         alert("Ajouté avec succès");
// //         setFormulaire({ title: "", image_path: "" });
// //         chargerDonnees();
// //       }
// //     }
// //   };

// //   const gererEdition = (item) => {
// //     setElementModifie(item);
// //     setFormulaire({
// //       title: item.title || "",
// //       image_path: item.image_path || "",
// //     });
// //   };

// // const gererFichier = async (e) => {
// //   const fichier = e.target.files[0];
// //   if (!fichier) return;

// //   try {
// //     const extension = fichier.name.split(".").pop();
// //     const nomFichier = `${Date.now()}.${extension}`;
// // const cheminFichier = `slider/${nomFichier}`;

// //     let { data, error: erreurUpload } = await supabase.storage
// //   .from("animalia")
// //   .upload(cheminFichier, fichier, {
// //     cacheControl: "3600",
// //     upsert: false,
// //   });

// // console.log("Upload result:", data, erreurUpload);

// //     if (erreurUpload) {
// //       alert("Échec de l'upload : " + erreurUpload.message);
// //       return;
// //     }

// //     setFormulaire((prev) => ({
// //       ...prev,
// //       image_path: cheminFichier,
// //     }));
// //   } catch (error) {
// //     alert("Erreur d'upload : " + error.message);
// //   }
// // };


// //   const gererSuppression = async (id) => {
// //     if (window.confirm("Voulez-vous vraiment supprimer cet élément ?")) {
// //       const { error } = await supabase.from("main").delete().eq("id", id);
// //       if (error) {
// //         alert("Échec de la suppression : " + error.message);
// //       } else {
// //         alert("Supprimé avec succès");
// //         chargerDonnees();
// //       }
// //     }
// //   };

// //   return (
// //     <div
// //       style={{
// //         minHeight: "100vh",
// //         display: "flex",
// //         flexDirection: "column",
// //         alignItems: "center",
// //         justifyContent: "center",
// //         padding: 20,
// //         backgroundColor: "#f8f9fa",
// //         fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
// //       }}
// //     >
// //       {/* <h2 style={{ marginBottom: 30, color: "#343a40" }}>
// //         Gestionnaire du Slider Principal
// //       </h2> */}

// //       {/* Formulaire d'ajout/modification */}
// //       <form
// //         onSubmit={gererSoumission}
// //         style={{
// //           display: "flex",
// //           flexWrap: "wrap",
// //           gap: 15,
// //           maxWidth: 700,
// //           backgroundColor: "#fff",
// //           padding: 20,
// //           borderRadius: 8,
// //           boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
// //           marginBottom: 40,
// //         }}
// //       >
// //         <h3 style={{ width: "100%", color: "#495057" }}>
// //           {elementModifie ? "Modifier la diapositive" : "Ajouter une diapositive"}
// //         </h3>

// //         <input
// //           type="text"
// //           name="title"
// //           placeholder="Titre"
// //           value={formulaire.title}
// //           onChange={gererChangement}
// //           required
// //           style={inputStyle}
// //         />

// //         {/* <label style={{ fontWeight: "600", marginBottom: 6 }}>
// //           Télécharger une image
// //         </label> */}
// //         <input
// //           type="file"
// //           accept="image/*"
// //           onChange={gererFichier}
// //           style={inputStyle}
// //         />
// // {previewUrl && (
// //   <img
// //     src={previewUrl}
// //     alt="Aperçu"
// //     style={{ maxWidth: "200px", marginTop: "10px", borderRadius: "6px" }}
// //   />
// // )}

// //         <div style={{ display: "flex", gap: 10, marginTop: 10, width: "100%" }}>
// //           <button type="submit" style={buttonStyle}>
// //             {elementModifie ? "Mettre à jour" : "Ajouter"}
// //           </button>
// //           {elementModifie && (
// //             <button
// //               type="button"
// //               onClick={() => {
// //                 setElementModifie(null);
// //                 setFormulaire({ title: "", image_path: "" });
// //               }}
// //               style={{ ...buttonStyle, backgroundColor: "#6c757d" }}
// //             >
// //               Annuler
// //             </button>
// //           )}
// //         </div>
// //       </form>

// //       {/* Message d'erreur */}
// //       {erreur && (
// //         <p style={{ color: "red", marginBottom: 20, fontWeight: "bold" }}>
// //           {erreur}
// //         </p>
// //       )}

// //       {/* État de chargement */}
// //       {chargement && <p>Chargement des diapositives...</p>}

// //       {/* Cartes horizontales */}
// //       <div
// //         style={{
// //           display: "flex",
// //           gap: 24,
// //           overflowX: "auto",
// //           maxWidth: "90vw",
// //           paddingBottom: 20,
// //           justifyContent: "center",
// //           scrollbarWidth: "thin",
// //         }}
// //       >
// //         {mainSlider.map((item) => (
// //           <div
// //             key={item.id}
// //             style={{
// //               minWidth: 280,
// //               backgroundColor: "#fff",
// //               borderRadius: 10,
// //               boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
// //               padding: 15,
// //               flexShrink: 0,
// //               display: "flex",
// //               flexDirection: "column",
// //               alignItems: "center",
// //             }}
// //           >
// //             <img
// //               src={
// //                 item.image_path
// //                   ? getImageUrl(item.image_path)
// //                   : "https://via.placeholder.com/280x150?text=Pas+d'image"
// //               }
// //               alt={item.title || "Image"}
// //               style={{
// //                 width: "100%",
// //                 height: 150,
// //                 objectFit: "cover",
// //                 borderRadius: 8,
// //                 marginBottom: 15,
// //               }}
// //             />

// //             <h4
// //               style={{
// //                 color: "#212529",
// //                 marginBottom: 8,
// //                 textAlign: "center",
// //                 minHeight: 48,
// //               }}
// //             >
// //               {item.title}
// //             </h4>

// //             <div style={{ display: "flex", gap: 12 }}>
// //               <button
// //                 onClick={() => gererEdition(item)}
// //                 style={{
// //                   ...buttonStyle,
// //                   backgroundColor: "rgba(255, 65, 180, 0.8)",
// //                 }}
// //               >
// //                 Modifier
// //               </button>
// //               <button
// //                 onClick={() => gererSuppression(item.id)}
// //                 style={{
// //                   ...buttonStyle,
// //                   backgroundColor: "rgba(220, 53, 69, 0.8)",
// //                 }}
// //               >
// //                 Supprimer
// //               </button>
// //             </div>
// //           </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // }

// // const inputStyle = {
// //   flex: "1 1 200px",
// //   padding: "10px 12px",
// //   borderRadius: 6,
// //   border: "1.5px solid #ced4da",
// //   fontSize: 16,
// //   outline: "none",
// //   transition: "border-color 0.3s",
// // };

// // const buttonStyle = {
// //   padding: "10px 18px",
// //   border: "none",
// //   borderRadius: 6,
// //   color: "#fff",
// //   fontWeight: "600",
// //   cursor: "pointer",
// //   flex: 1,
// //   backgroundColor: "gray",
// //   transition: "background-color 0.3s",
// // };

// // import React, { useEffect, useState } from "react";
// // import { supabase } from "../lib/supabaseClient.ts";

// // const getImageUrl = (path) => {
// //   const { data } = supabase.storage.from("animalia").getPublicUrl(path);
// //   return data?.publicUrl || "";
// // };

// // export default function GestionnaireSliderPrincipal() {
// //   const [slides, setSlides] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [editing, setEditing] = useState(null);

// //   const [form, setForm] = useState({
// //     title: "",
// //     image_path: "",
// //     link: "",
// //     order_index: 0,
// //     is_active: true,
// //   });

// //   const [preview, setPreview] = useState("");

// //   const fetchSlides = async () => {
// //     setLoading(true);

// //     const { data } = await supabase
// //       .from("main_slider")
// //       .select("*")
// //       .order("order_index", { ascending: true });

// //     setSlides(data || []);
// //     setLoading(false);
// //   };

// //   useEffect(() => {
// //     fetchSlides();
// //   }, []);

// //   useEffect(() => {
// //     if (form.image_path) {
// //       setPreview(getImageUrl(form.image_path));
// //     }
// //   }, [form.image_path]);

// //   const handleChange = (e) => {
// //     const { name, value } = e.target;

// //     setForm((prev) => ({
// //       ...prev,
// //       [name]: name === "order_index" ? Number(value) : value,
// //     }));
// //   };

// //   const handleFile = async (e) => {
// //     const file = e.target.files[0];
// //     if (!file) return;

// //     const ext = file.name.split(".").pop();
// //     const path = `slider/${Date.now()}.${ext}`;

// //     const { error } = await supabase.storage
// //       .from("animalia")
// //       .upload(path, file);

// //     if (error) return alert(error.message);

// //     setForm((prev) => ({ ...prev, image_path: path }));
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     if (editing) {
// //       await supabase.from("main_slider").update(form).eq("id", editing.id);
// //       setEditing(null);
// //     } else {
// //       await supabase.from("main_slider").insert([form]);
// //     }

// //     setForm({
// //       title: "",
// //       image_path: "",
// //       link: "",
// //       order_index: 0,
// //       is_active: true,
// //     });

// //     fetchSlides();
// //   };

// //   const handleEdit = (item) => {
// //     setEditing(item);
// //     setForm({
// //       title: item.title || "",
// //       image_path: item.image_path || "",
// //       link: item.link || "",
// //       order_index: item.order_index || 0,
// //       is_active: item.is_active ?? true,
// //     });
// //   };

// //   const handleDelete = async (id) => {
// //     if (!window.confirm("Delete this slide?")) return;

// //     await supabase.from("main_slider").delete().eq("id", id);
// //     fetchSlides();
// //   };

// //   const toggleActive = async (item) => {
// //     await supabase
// //       .from("main_slider")
// //       .update({ is_active: !item.is_active })
// //       .eq("id", item.id);

// //     fetchSlides();
// //   };

// //   return (
// //     <div style={styles.page}>
// //       <div style={styles.container}>
// //         <h1 style={styles.title}>🎛 Slider Manager</h1>

// //         {/* FORM */}
// //         <div style={styles.formCard}>
// //           <h2 style={styles.subtitle}>
// //             {editing ? "Edit Slide" : "Add New Slide"}
// //           </h2>

// //           <form onSubmit={handleSubmit} style={styles.form}>
// //             <input
// //               name="title"
// //               placeholder="Title"
// //               value={form.title}
// //               onChange={handleChange}
// //               style={styles.input}
// //             />

// //             <input
// //               name="link"
// //               placeholder="/shop-details/123"
// //               value={form.link}
// //               onChange={handleChange}
// //               style={styles.input}
// //             />

// //             <input
// //               name="order_index"
// //               type="number"
// //               placeholder="Order"
// //               value={form.order_index}
// //               onChange={handleChange}
// //               style={styles.input}
// //             />

// //             <input type="file" onChange={handleFile} style={styles.input} />

// //             {preview && (
// //               <img src={preview} style={styles.preview} alt="preview" />
// //             )}

// //             <button style={styles.primaryBtn}>
// //               {editing ? "Update Slide" : "Add Slide"}
// //             </button>
// //           </form>
// //         </div>

// //         {/* GRID */}
// //         <div style={styles.grid}>
// //           {loading ? (
// //             <p>Loading...</p>
// //           ) : (
// //             slides.map((item) => (
// //               <div key={item.id} style={styles.card}>
// //                 <img
// //                   src={getImageUrl(item.image_path)}
// //                   style={styles.image}
// //                 />

// //                 <div style={styles.cardBody}>
// //                   <h3 style={styles.cardTitle}>{item.title}</h3>

// //                   <p style={styles.text}>Order: {item.order_index}</p>

// //                   <span
// //                     style={{
// //                       ...styles.badge,
// //                       background: item.is_active ? "#22c55e" : "#ef4444",
// //                     }}
// //                   >
// //                     {item.is_active ? "Active" : "Hidden"}
// //                   </span>

// //                   <div style={styles.actions}>
// //                     <button
// //                       onClick={() => handleEdit(item)}
// //                       style={styles.editBtn}
// //                     >
// //                       Edit
// //                     </button>

// //                     <button
// //                       onClick={() => handleDelete(item.id)}
// //                       style={styles.deleteBtn}
// //                     >
// //                       Delete
// //                     </button>

// //                     <button
// //                       onClick={() => toggleActive(item)}
// //                       style={styles.toggleBtn}
// //                     >
// //                       Toggle
// //                     </button>
// //                   </div>
// //                 </div>
// //               </div>
// //             ))
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // /* ===== STYLES ===== */
// // const styles = {
// //   page: {
// //     background: "#0f172a",
// //     minHeight: "100vh",
// //     padding: "40px 20px",
// //     color: "#fff",
// //   },
// //   container: {
// //     maxWidth: 1100,
// //     margin: "0 auto",
// //   },
// //   title: {
// //     fontSize: 28,
// //     marginBottom: 30,
// //     fontWeight: 700,
// //   },

// //   formCard: {
// //     background: "#111827",
// //     padding: 20,
// //     borderRadius: 16,
// //     marginBottom: 30,
// //   },

// //   subtitle: {
// //     marginBottom: 15,
// //   },

// //   form: {
// //     display: "grid",
// //     gap: 10,
// //   },

// //   input: {
// //     padding: 12,
// //     borderRadius: 10,
// //     border: "1px solid #334155",
// //     background: "#0b1220",
// //     color: "#fff",
// //     outline: "none",
// //   },

// //   preview: {
// //     width: 220,
// //     borderRadius: 10,
// //     marginTop: 10,
// //   },

// //   primaryBtn: {
// //     padding: 12,
// //     borderRadius: 10,
// //     background: "#3b82f6",
// //     color: "#fff",
// //     border: "none",
// //     fontWeight: "600",
// //     cursor: "pointer",
// //   },

// //   grid: {
// //     display: "grid",
// //     gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
// //     gap: 20,
// //   },

// //   card: {
// //     background: "#111827",
// //     borderRadius: 14,
// //     overflow: "hidden",
// //     border: "1px solid #1f2937",
// //   },

// //   image: {
// //     width: "100%",
// //     height: 150,
// //     objectFit: "cover",
// //   },

// //   cardBody: {
// //     padding: 15,
// //   },

// //   cardTitle: {
// //     marginBottom: 6,
// //   },

// //   text: {
// //     fontSize: 13,
// //     opacity: 0.7,
// //   },

// //   badge: {
// //     display: "inline-block",
// //     padding: "4px 10px",
// //     borderRadius: 999,
// //     fontSize: 12,
// //     marginTop: 8,
// //   },

// //   actions: {
// //     display: "flex",
// //     gap: 8,
// //     marginTop: 12,
// //   },

// //   editBtn: {
// //     flex: 1,
// //     padding: 8,
// //     borderRadius: 8,
// //     border: "none",
// //     background: "#f59e0b",
// //     color: "#000",
// //     cursor: "pointer",
// //   },

// //   deleteBtn: {
// //     flex: 1,
// //     padding: 8,
// //     borderRadius: 8,
// //     border: "none",
// //     background: "#ef4444",
// //     color: "#fff",
// //     cursor: "pointer",
// //   },

// //   toggleBtn: {
// //     flex: 1,
// //     padding: 8,
// //     borderRadius: 8,
// //     border: "none",
// //     background: "#64748b",
// //     color: "#fff",
// //     cursor: "pointer",
// //   },
// // };
// import React, { useEffect, useState } from "react";
// import { supabase } from "../lib/supabaseClient.ts";

// const getImageUrl = (path) => {
//   const { data } = supabase.storage.from("animalia").getPublicUrl(path);
//   return data?.publicUrl || "";
// };

// export default function GestionnaireSliderPrincipal() {
//   const [slides, setSlides] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [editing, setEditing] = useState(null);

//   const [form, setForm] = useState({
//     title: "",
//     image: "",
//     link: "",
//     order_index: 0,
//     is_active: true,
//   });

//   const [preview, setPreview] = useState("");

//   /* ================= CHARGEMENT ================= */
//   const fetchSlides = async () => {
//     setLoading(true);

//     const { data, error } = await supabase
//       .from("main_slider")
//       .select("*")
//       .order("order_index", { ascending: true });

//     if (!error) setSlides(data || []);

//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchSlides();
//   }, []);

//   /* ================= APERÇU ================= */
//   useEffect(() => {
//     if (form.image) {
//       setPreview(getImageUrl(form.image));
//     }
//   }, [form.image]);

//   /* ================= CHANGEMENT INPUT ================= */
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm((prev) => ({
//       ...prev,
//       [name]: name === "order_index" ? Number(value) : value,
//     }));
//   };

//   /* ================= UPLOAD IMAGE ================= */
//   const handleFile = async (e) => {
//     const fichier = e.target.files[0];
//     if (!fichier) return;

//     const extension = fichier.name.split(".").pop();
//     const chemin = `slider/${Date.now()}.${extension}`;

//     const { error } = await supabase.storage
//       .from("animalia")
//       .upload(chemin, fichier);

//     if (error) {
//       alert(error.message);
//       return;
//     }

//     setForm((prev) => ({
//       ...prev,
//       image: chemin,
//     }));
//   };

//   /* ================= ENVOI ================= */
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!form.image) {
//       alert("Veuillez télécharger une image");
//       return;
//     }

//     if (editing) {
//       const { error } = await supabase
//         .from("main_slider")
//         .update({
//           title: form.title,
//           image: form.image,
//           link: form.link,
//           order_index: form.order_index,
//           is_active: form.is_active,
//         })
//         .eq("id", editing.id);

//       if (error) return alert(error.message);

//       setEditing(null);
//     } else {
//       const { error } = await supabase.from("main_slider").insert([
//         {
//           title: form.title,
//           image: form.image,
//           link: form.link,
//           order_index: form.order_index,
//           is_active: form.is_active,
//         },
//       ]);

//       if (error) return alert(error.message);
//     }

//     setForm({
//       title: "",
//       image: "",
//       link: "",
//       order_index: 0,
//       is_active: true,
//     });

//     setPreview("");
//     fetchSlides();
//   };

//   /* ================= EDITION ================= */
//   const handleEdit = (item) => {
//     setEditing(item);

//     setForm({
//       title: item.title || "",
//       image: item.image || "",
//       link: item.link || "",
//       order_index: item.order_index || 0,
//       is_active: item.is_active ?? true,
//     });
//   };

//   /* ================= SUPPRESSION ================= */
//   const handleDelete = async (id) => {
//     if (!window.confirm("Supprimer ce slide ?")) return;

//     const { error } = await supabase
//       .from("main_slider")
//       .delete()
//       .eq("id", id);

//     if (error) return alert(error.message);

//     fetchSlides();
//   };

//   /* ================= TOGGLE ================= */
//   const toggleActive = async (item) => {
//     await supabase
//       .from("main_slider")
//       .update({ is_active: !item.is_active })
//       .eq("id", item.id);

//     fetchSlides();
//   };

//   /* ================= UI ================= */
//   return (
//     <div style={styles.page}>
//       <div style={styles.container}>
//         <h1 style={styles.title}> Gestionnaire du Slider</h1>

//         {/* FORMULAIRE */}
//         <div style={styles.formCard}>
//           <h2 style={styles.subtitle}>
//             {editing ? " Modifier le slide" : " Ajouter un slide"}
//           </h2>

//           <form onSubmit={handleSubmit} style={styles.form}>
//             <input
//               name="title"
//               placeholder="Titre du slide..."
//               value={form.title}
//               onChange={handleChange}
//               style={styles.input}
//             />

//             <input
//               name="link"
//               placeholder="/shop-details/123"
//               value={form.link}
//               onChange={handleChange}
//               style={styles.input}
//             />

//             <input
//               name="order_index"
//               type="number"
//               placeholder="Ordre"
//               value={form.order_index}
//               onChange={handleChange}
//               style={styles.input}
//             />

//             <input type="file" onChange={handleFile} style={styles.input} />

//             {preview && (
//               <img src={preview} alt="aperçu" style={styles.preview} />
//             )}

//             <button style={styles.primaryBtn}>
//               {editing ? "Mettre à jour " : "Ajouter "}
//             </button>
//           </form>
//         </div>

//         {/* GRILLE */}
//         <div style={styles.grid}>
//           {loading ? (
//             <p>Chargement...</p>
//           ) : (
//             slides.map((item) => (
//               <div key={item.id} style={styles.card}>
//                 <img
//                   src={getImageUrl(item.image)}
//                   style={styles.image}
//                   alt="slide"
//                 />

//                 <div style={styles.cardBody}>
//                   <h3 style={styles.cardTitle}>{item.title}</h3>

//                   <p style={styles.text}>Ordre : {item.order_index}</p>

//                   <span
//                     style={{
//                       ...styles.badge,
//                       background: item.is_active ? "#ff4fa3" : "#ddd",
//                       color: item.is_active ? "#fff" : "#333",
//                     }}
//                   >
//                     {item.is_active ? "Actif " : "Masqué"}
//                   </span>

//                   <div style={styles.actions}>
//                     <button
//                       onClick={() => handleEdit(item)}
//                       style={styles.editBtn}
//                     >
//                       Modifier 
//                     </button>

//                     <button
//                       onClick={() => handleDelete(item.id)}
//                       style={styles.deleteBtn}
//                     >
//                       Supprimer 
//                     </button>

//                     <button
//                       onClick={() => toggleActive(item)}
//                       style={styles.toggleBtn}
//                     >
//                       Activer 
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             ))
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ================= STYLES ================= */
// const styles = {
//   page: {
//     background: "#fff5fb",
//     minHeight: "100vh",
//     padding: 40,
//     fontFamily: "Arial",
//   },

//   container: {
//     maxWidth: 1100,
//     margin: "0 auto",
//   },

//   title: {
//     textAlign: "center",
//     fontSize: 30,
//     color: "#ff4fa3",
//     marginBottom: 30,
//     fontWeight: 700,
//   },

//   formCard: {
//     background: "#fff",
//     padding: 20,
//     borderRadius: 18,
//     border: "2px solid #ffd1e8",
//     marginBottom: 30,
//   },

//   subtitle: {
//     color: "#ff4fa3",
//     marginBottom: 10,
//   },

//   form: {
//     display: "grid",
//     gap: 10,
//   },

//   input: {
//     padding: 12,
//     borderRadius: 10,
//     border: "1px solid #ffd1e8",
//     outline: "none",
//   },

//   preview: {
//     width: 200,
//     borderRadius: 10,
//     border: "2px solid #ffd1e8",
//   },

//   primaryBtn: {
//     padding: 12,
//     borderRadius: 12,
//     background: "linear-gradient(135deg,#ff4fa3,#ff85c2)",
//     color: "#fff",
//     border: "none",
//     fontWeight: 600,
//     cursor: "pointer",
//   },

//   grid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))",
//     gap: 20,
//   },

//   card: {
//     background: "#fff",
//     borderRadius: 16,
//     overflow: "hidden",
//     border: "1px solid #ffd1e8",
//   },

//   image: {
//     width: "100%",
//     height: 150,
//     objectFit: "cover",
//   },

//   cardBody: {
//     padding: 15,
//   },

//   cardTitle: {
//     marginBottom: 5,
//   },

//   text: {
//     fontSize: 13,
//     opacity: 0.7,
//   },

//   badge: {
//     display: "inline-block",
//     padding: "4px 10px",
//     borderRadius: 999,
//     fontSize: 12,
//     marginTop: 8,
//   },

//   actions: {
//     display: "flex",
//     gap: 8,
//     marginTop: 12,
//   },

//   editBtn: {
//     flex: 1,
//     padding: 8,
//     borderRadius: 10,
//     border: "none",
//     background: "#ffe0f0",
//     color: "#ff4fa3",
//     cursor: "pointer",
//     fontWeight: 600,
//   },

//   deleteBtn: {
//     flex: 1,
//     padding: 8,
//     borderRadius: 10,
//     border: "none",
//     background: "#ffe5e5",
//     color: "#ff4d4d",
//     cursor: "pointer",
//     fontWeight: 600,
//   },

//   toggleBtn: {
//     flex: 1,
//     padding: 8,
//     borderRadius: 10,
//     border: "none",
//     background: "#e0f2ff",
//     color: "#3b82f6",
//     cursor: "pointer",
//     fontWeight: 600,
//   },
// };
import React, { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient.ts";

const getImageUrl = (path) => {
  if (!path) return "";
  const { data } = supabase.storage.from("animalia").getPublicUrl(path);
  return data?.publicUrl || "";
};

export default function GestionnaireSliderPrincipal() {
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);

  const [form, setForm] = useState({
    title: "",
    image_desktop: "",
    image_mobile: "",
    link: "",
    order_index: 0,
    is_active: true,
  });

  const [previewDesktop, setPreviewDesktop] = useState("");
  const [previewMobile, setPreviewMobile] = useState("");

  /* ================= CHARGEMENT ================= */
  const fetchSlides = async () => {
    setLoading(true);

    const { data, error } = await supabase
      .from("main_slider")
      .select("*")
      .order("order_index", { ascending: true });

    if (!error) setSlides(data || []);

    setLoading(false);
  };

  useEffect(() => {
    fetchSlides();
  }, []);

  /* ================= APERÇU ================= */
  useEffect(() => {
    if (form.image_desktop) {
      setPreviewDesktop(getImageUrl(form.image_desktop));
    }
  }, [form.image_desktop]);

  useEffect(() => {
    if (form.image_mobile) {
      setPreviewMobile(getImageUrl(form.image_mobile));
    }
  }, [form.image_mobile]);

  /* ================= CHANGEMENT INPUT ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: name === "order_index" ? Number(value) : value,
    }));
  };

  /* ================= UPLOAD IMAGE ================= */
  const handleFile = async (e, imageType) => {
    const fichier = e.target.files[0];
    if (!fichier) return;

    const extension = fichier.name.split(".").pop();
    const chemin = `slider/${imageType}-${Date.now()}.${extension}`;

    const { error } = await supabase.storage
      .from("animalia")
      .upload(chemin, fichier);

    if (error) {
      alert(error.message);
      return;
    }

    setForm((prev) => ({
      ...prev,
      [imageType === "desktop" ? "image_desktop" : "image_mobile"]: chemin,
    }));
  };

  /* ================= ENVOI ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.image_desktop) {
      alert("Veuillez télécharger une image pour le desktop");
      return;
    }

    if (!form.image_mobile) {
      alert("Veuillez télécharger une image pour le mobile");
      return;
    }

    if (editing) {
      const { error } = await supabase
        .from("main_slider")
        .update({
          title: form.title,
          image_desktop: form.image_desktop,
          image_mobile: form.image_mobile,
          link: form.link,
          order_index: form.order_index,
          is_active: form.is_active,
        })
        .eq("id", editing.id);

      if (error) return alert(error.message);

      setEditing(null);
    } else {
      const { error } = await supabase.from("main_slider").insert([
        {
          title: form.title,
          image_desktop: form.image_desktop,
          image_mobile: form.image_mobile,
          link: form.link,
          order_index: form.order_index,
          is_active: form.is_active,
        },
      ]);

      if (error) return alert(error.message);
    }

    setForm({
      title: "",
      image_desktop: "",
      image_mobile: "",
      link: "",
      order_index: 0,
      is_active: true,
    });

    setPreviewDesktop("");
    setPreviewMobile("");
    fetchSlides();
  };

  /* ================= EDITION ================= */
  const handleEdit = (item) => {
    setEditing(item);

    setForm({
      title: item.title || "",
      image_desktop: item.image_desktop || "",
      image_mobile: item.image_mobile || "",
      link: item.link || "",
      order_index: item.order_index || 0,
      is_active: item.is_active ?? true,
    });
  };

  /* ================= SUPPRESSION ================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer ce slide ?")) return;

    const { error } = await supabase
      .from("main_slider")
      .delete()
      .eq("id", id);

    if (error) return alert(error.message);

    fetchSlides();
  };

  /* ================= TOGGLE ================= */
  const toggleActive = async (item) => {
    await supabase
      .from("main_slider")
      .update({ is_active: !item.is_active })
      .eq("id", item.id);

    fetchSlides();
  };

  /* ================= UI ================= */
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>Gestionnaire du Slider</h1>

        {/* FORMULAIRE */}
        <div style={styles.formCard}>
          <h2 style={styles.subtitle}>
            {editing ? "Modifier le slide" : "Ajouter un slide"}
          </h2>

          <form onSubmit={handleSubmit} style={styles.form}>
            <input
              name="title"
              placeholder="Titre du slide..."
              value={form.title}
              onChange={handleChange}
              style={styles.input}
            />

            <input
              name="link"
              placeholder="/shop-details/123"
              value={form.link}
              onChange={handleChange}
              style={styles.input}
            />

            <input
              name="order_index"
              type="number"
              placeholder="Ordre"
              value={form.order_index}
              onChange={handleChange}
              style={styles.input}
            />

            {/* DESKTOP IMAGE */}
            <div style={styles.imageSection}>
              <label style={styles.label}>Image Desktop</label>
              <input 
                type="file" 
                onChange={(e) => handleFile(e, "desktop")} 
                style={styles.input}
                accept="image/*"
              />
              {previewDesktop && (
                <div style={styles.previewContainer}>
                  <img src={previewDesktop} alt="aperçu desktop" style={styles.preview} />
                  <p style={styles.previewLabel}>Desktop (1920x1080+)</p>
                </div>
              )}
            </div>

            {/* MOBILE IMAGE */}
            <div style={styles.imageSection}>
              <label style={styles.label}>Image Mobile</label>
              <input 
                type="file" 
                onChange={(e) => handleFile(e, "mobile")} 
                style={styles.input}
                accept="image/*"
              />
              {previewMobile && (
                <div style={styles.previewContainer}>
                  <img src={previewMobile} alt="aperçu mobile" style={{...styles.preview, maxWidth: 150}} />
                  <p style={styles.previewLabel}>Mobile (750x1000+)</p>
                </div>
              )}
            </div>

            <button style={styles.primaryBtn}>
              {editing ? "Mettre à jour" : "Ajouter"}
            </button>
          </form>
        </div>

        {/* GRILLE */}
        <div style={styles.grid}>
          {loading ? (
            <p>Chargement...</p>
          ) : (
            slides.map((item) => (
              <div key={item.id} style={styles.card}>
                <div style={styles.previewGrid}>
                  <div>
                    <img
                      src={getImageUrl(item.image_desktop)}
                      style={styles.image}
                      alt="slide desktop"
                    />
                    <p style={styles.deviceLabel}>Desktop</p>
                  </div>
                  <div>
                    <img
                      src={getImageUrl(item.image_mobile)}
                      style={{...styles.image, maxHeight: 120}}
                      alt="slide mobile"
                    />
                    <p style={styles.deviceLabel}>Mobile</p>
                  </div>
                </div>

                <div style={styles.cardBody}>
                  <h3 style={styles.cardTitle}>{item.title}</h3>

                  <p style={styles.text}>Ordre: {item.order_index}</p>

                  <span
                    style={{
                      ...styles.badge,
                      background: item.is_active ? "#ff4fa3" : "#ddd",
                      color: item.is_active ? "#fff" : "#333",
                    }}
                  >
                    {item.is_active ? "Actif" : "Masqué"}
                  </span>

                  <div style={styles.actions}>
                    <button
                      onClick={() => handleEdit(item)}
                      style={styles.editBtn}
                    >
                      Modifier
                    </button>

                    <button
                      onClick={() => handleDelete(item.id)}
                      style={styles.deleteBtn}
                    >
                      Supprimer
                    </button>

                    <button
                      onClick={() => toggleActive(item)}
                      style={styles.toggleBtn}
                    >
                      Activer
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */
const styles = {
  page: {
    background: "#fff5fb",
    minHeight: "100vh",
    padding: 40,
    fontFamily: "Arial",
  },

  container: {
    maxWidth: 1100,
    margin: "0 auto",
  },

  title: {
    textAlign: "center",
    fontSize: 30,
    color: "#ff4fa3",
    marginBottom: 30,
    fontWeight: 700,
  },

  formCard: {
    background: "#fff",
    padding: 20,
    borderRadius: 18,
    border: "2px solid #ffd1e8",
    marginBottom: 30,
  },

  subtitle: {
    color: "#ff4fa3",
    marginBottom: 20,
  },

  form: {
    display: "grid",
    gap: 15,
  },

  imageSection: {
    border: "1px solid #ffd1e8",
    padding: 15,
    borderRadius: 10,
    background: "#fff9fc",
  },

  label: {
    display: "block",
    marginBottom: 8,
    fontWeight: 600,
    color: "#ff4fa3",
    fontSize: 14,
  },

  input: {
    padding: 12,
    borderRadius: 10,
    border: "1px solid #ffd1e8",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
  },

  previewContainer: {
    marginTop: 10,
  },

  preview: {
    maxWidth: "100%",
    maxHeight: 200,
    borderRadius: 10,
    border: "2px solid #ffd1e8",
  },

  previewLabel: {
    fontSize: 12,
    color: "#999",
    marginTop: 5,
  },

  primaryBtn: {
    padding: 12,
    borderRadius: 12,
    background: "linear-gradient(135deg,#ff4fa3,#ff85c2)",
    color: "#fff",
    border: "none",
    fontWeight: 600,
    cursor: "pointer",
    fontSize: 16,
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))",
    gap: 20,
  },

  card: {
    background: "#fff",
    borderRadius: 16,
    overflow: "hidden",
    border: "1px solid #ffd1e8",
  },

  previewGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 10,
    padding: 10,
    background: "#f5f5f5",
  },

  image: {
    width: "100%",
    height: 150,
    objectFit: "cover",
    borderRadius: 8,
  },

  deviceLabel: {
    fontSize: 11,
    textAlign: "center",
    color: "#999",
    marginTop: 5,
    fontWeight: 600,
  },

  cardBody: {
    padding: 15,
  },

  cardTitle: {
    marginBottom: 8,
    color: "#333",
  },

  text: {
    fontSize: 13,
    opacity: 0.7,
  },

  badge: {
    display: "inline-block",
    padding: "4px 10px",
    borderRadius: 999,
    fontSize: 12,
    marginTop: 8,
  },

  actions: {
    display: "flex",
    gap: 8,
    marginTop: 12,
  },

  editBtn: {
    flex: 1,
    padding: 8,
    borderRadius: 10,
    border: "none",
    background: "#ffe0f0",
    color: "#ff4fa3",
    cursor: "pointer",
    fontWeight: 600,
  },

  deleteBtn: {
    flex: 1,
    padding: 8,
    borderRadius: 10,
    border: "none",
    background: "#ffe5e5",
    color: "#ff4d4d",
    cursor: "pointer",
    fontWeight: 600,
  },

  toggleBtn: {
    flex: 1,
    padding: 8,
    borderRadius: 10,
    border: "none",
    background: "#e0f2ff",
    color: "#3b82f6",
    cursor: "pointer",
    fontWeight: 600,
  },
};